import { createSelector } from "reselect";
import { RootState } from "../../types/store";

const getProfileState = ({ profile }: RootState) => profile;

export const profileSelector = createSelector([getProfileState], (profile) => profile);
export const userProfileSelector = createSelector([profileSelector], (data) => data);
export const userActivitiesSelector = createSelector([profileSelector], (data) => data);
